import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import 'dayjs/locale/en' // import locale
import App from './App'
import dayjs from 'dayjs'
import { AuthProvider } from './contexts/auth'
import { BrowserRouter } from 'react-router-dom'

dayjs.locale('en')

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
    <BrowserRouter>
        <AuthProvider>
            <App />
        </AuthProvider>
    </BrowserRouter>
)
